const TRIP_TYPE_COLORS = [
  { background: "#ECFDFF", color: "#06AED4" },
  { background: "#FEF6EE", color: "#B93815" },
  { background: "#F4F3FF", color: "#5925DC" },
  { background: "#E0F2FE", color: "#0C4A6E" },
  { background: "#FFFBEA", color: "#92400E" },
];

const DEFAULT_BADGE = { background: "#F2F4F7", color: "#344054" };

// One-Way / Two-Way trip direction badge colors (family cards, mobile + desktop).
// Soft light-bg / dark-text pairs, matching the trip-type badge palette — blue
// (from #0F4271) for One-Way, gold (from #FABE00) for Two-Way.
export const DIRECTION_BADGE = {
  oneWay: { background: "#EAF1F8", color: "#0F4271" },
  twoWay: { background: "#FEF7E0", color: "#946200" },
};

// Colors a trip-type / session badge by its index in the institution's trip
// types (matching the family & stop badge palette). Neutral gray fallback for
// "none" / unknown sessions.
export const getTripBadgeProps = (tripTypeId, tripTypes = []) =>
  TRIP_TYPE_COLORS[tripTypes.findIndex((t) => t.id === tripTypeId)] ||
  DEFAULT_BADGE;
